/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Aircraft
 */
export interface Aircraft {
    /**
     * The three-character IATA code for the aircraft
     * @type {string}
     * @memberof Aircraft
     */
    iataCode: string;
    /**
     * Duffel's unique identifier for the resource
     * @type {string}
     * @memberof Aircraft
     */
    id: string;
    /**
     * The name of the aircraft
     * @type {string}
     * @memberof Aircraft
     */
    name: string;
}

/**
 * Check if a given object implements the Aircraft interface.
 */
export function instanceOfAircraft(value: object): value is Aircraft {
    if (!('iataCode' in value) || value['iataCode'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function AircraftFromJSON(json: any): Aircraft {
    return AircraftFromJSONTyped(json, false);
}

export function AircraftFromJSONTyped(json: any, ignoreDiscriminator: boolean): Aircraft {
    if (json == null) {
        return json;
    }
    return {
        
        'iataCode': json['iata_code'],
        'id': json['id'],
        'name': json['name'],
    };
}

export function AircraftToJSON(json: any): Aircraft {
    return AircraftToJSONTyped(json, false);
}

export function AircraftToJSONTyped(value?: Aircraft | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'iata_code': value['iataCode'],
        'id': value['id'],
        'name': value['name'],
    };
}

